// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"

/* Active Storage */
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

/* Stimulus controllers */
import "./controllers"
